export default function HRMyManager() {
  return (
    <div className="max-w-2xl">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-1">Мой менеджер</h2>
        <p className="text-slate-500 text-sm">Ваш персональный куратор по трудоустройству</p>
      </div>

      <div className="bg-[#13161f] border border-[#1e2130] rounded-2xl p-10 flex flex-col items-center text-center">
        <div className="w-20 h-20 rounded-2xl bg-slate-800/60 border border-[#2a2d3e] flex items-center justify-center mb-5">
          <i className="ri-user-search-line text-4xl text-slate-600" />
        </div>
        <h3 className="text-lg font-semibold text-slate-300 mb-2">Менеджер ещё не назначен</h3>
        <p className="text-sm text-slate-600 leading-relaxed max-w-sm">
          После завершения оформления вам будет назначен персональный менеджер.
          Здесь появятся его контактные данные.
        </p>
      </div>

      <div className="mt-4 bg-[#13161f] border border-[#1e2130] rounded-2xl p-6">
        <div className="flex items-start gap-3">
          <span className="w-5 h-5 flex items-center justify-center text-amber-400 flex-shrink-0 mt-0.5">
            <i className="ri-lightbulb-line" />
          </span>
          <div>
            <p className="text-sm font-medium text-slate-300 mb-1">Совет</p>
            <p className="text-sm text-slate-500 leading-relaxed">
              По всем вопросам оформления обращайтесь к тому, кто пригласил вас на эту платформу.
              После назначения менеджер свяжется с вами через Telegram.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
